<template>
  <div name="js-pdf" id="jsPDF">
    {{title}}
    <!-- <input type="button" @click="download()" value="download" />
    <input type="button" @click="html()" value="html" /> -->
  </div>
</template>

<script>
// import $ from 'jquery'
// var JsPDF = require('src/assets/js/jspdf.debug.js')

export default {
  name: 'js-pdf',
  data () {
    return {
      title: 'JS PDF'
    }
  }
  // methods: {
  //   download () {
  //     var doc = new JsPDF()
  //     doc.text('Hello world!', 100, 100)
  //     doc.save('download.pdf')
  //   },
  //   html () {
  //     var doc = new JsPDF()
  //     doc.fromHTML($('.content-wrapper').get(0), 15, 15)
  //     doc.save('html.pdf')
  //   }
  // }
}
</script>


// WEBPACK FOOTER //
// component.vue?812f91e8